<script>
  import {onMount} from "svelte";
  import {getUserStats} from "../../models/stats.js";
  import {user} from "../../models/user.js";
  import Alert from "../../components/Alert.svelte";
  import PuzzleStats from "../../components/PuzzleStats.svelte";

  let stats = null;
  let error = null;
  let loading = true;

  onMount(async () => {
    try {
      const data = await getUserStats();
      if (data?.error) {
        error = data.error;
      } else {
        stats = data;
      }
    } catch (e) {
      error = "Unable to load your stats. Please try again.";
    } finally {
      loading = false;
    }
  });
</script>

<style type="text/less">
  h2 {
    margin-bottom: var(--spacing);
  }

  .upsell {
    text-align: center;
    padding: var(--spacing-lg) var(--spacing);
    color: var(--col-gray-40);

    p {
      margin-bottom: var(--spacing);
    }
  }
</style>

<h2>Puzzle Stats (Beta)</h2>

{#if loading}
  <p>Loading...</p>
{:else if !$user?.subscriptionDetails}
  <div class="upsell">
    <p>Puzzle Stats are available to active members. Join a membership plan to track your unique puzzles, total pieces, top brands, and more.</p>
    <a href="/ways-to-rent" class="btn">View Membership Plans</a>
  </div>
{:else if error}
  <Alert type="danger" icon="warning">{error}</Alert>
{:else if stats}
  <PuzzleStats {stats} />
{/if}
